import {
  GET_USER,
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  GET_OPERATIVES,
  GET_OPERATIVES_FAIL,
  GET_OPERATIVES_SUCCESS,
  GET_TECHADVISORS,
  GET_TECHADVISORS_FAIL,
  GET_TECHADVISORS_SUCCESS,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  SET_STATE_USER,
  UPDATE_USER_CHECK,
  UPDATE_OPERATIVE_CHECK,
  UPDATE_TECHADVISOR_CHECK,
  UPDATE_USER_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_USER,
  payload: loading,
})

export const getUsers = ( params ) => ({
  type: GET_USERS,
  payload: { params },
})

export const getUsersSuccess = (users, totalPages, currentPage) => ({
  type: GET_USERS_SUCCESS,
  payload: { users:users, total:totalPages, currentPage:currentPage}
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const getOperatives = ( params ) => ({
  type: GET_OPERATIVES,
  payload: { params },
})

export const getOperativesSuccess = (operatives, totalPages, currentPage) => ({
  type: GET_OPERATIVES_SUCCESS,
  payload: { operatives:operatives, totalOperatives:totalPages, currentPageOperatives:currentPage}
})

export const getOperativesFail = error => ({
  type: GET_OPERATIVES_FAIL,
  payload: error,
})

export const getTechAdvisors = ( params ) => ({
  type: GET_TECHADVISORS,
  payload: { params },
})

export const getTechAdvisorsSuccess = (techAdvisors, totalPages, currentPage) => ({
  type: GET_TECHADVISORS_SUCCESS,
  payload: { techAdvisors:techAdvisors, totalTechAdvisors:totalPages, currentPageTechAdvisors:currentPage}
})

export const getTechAdvisorsFail = error => ({
  type: GET_TECHADVISORS_FAIL,
  payload: error,
})

export const addNewUser = user => ({
  type: ADD_NEW_USER,
  payload: user,
})

export const addUserSuccess = user => ({
  type: ADD_USER_SUCCESS,
  payload: user,
})  

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
})

export const updateUser = user => ({
  type: UPDATE_USER,
  payload: user,
})

export const updateUserStatus = user => ({
  type: UPDATE_USER_STATUS,
  payload: user,
})

export const updateUserSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
})

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const deleteUser = user => ({
  type: DELETE_USER,
  payload: user,
})

export const deleteUserSuccess = id => ({
  type: DELETE_USER_SUCCESS,
  id,
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})

export const getUser = () => ({
  type: GET_USER,
})

export const getUserSuccess = user => ({
  type: GET_USER_SUCCESS,
  payload: user,
})

export const getUserFail = error => ({
  type: GET_USER_FAIL,
  payload: error,
})

export const updateUserCheck = (id, checkValue) => ({
  type: UPDATE_USER_CHECK,
  payload: { id:id, checked:checkValue },
})

export const updateTechAdvisorCheck = (id, checkValue) => ({
  type: UPDATE_TECHADVISOR_CHECK,
  payload: { id:id, checked:checkValue },
})

export const updateOperativeCheck = (id, checkValue) => ({
  type: UPDATE_OPERATIVE_CHECK,
  payload: { id:id, checked:checkValue },
})
